import { createSelector } from 'reselect';

import { getBootstrapper } from './getBootstrapper';

export const getConfiguratorIsInitialized = createSelector(
  getBootstrapper,
  bootstrapper => bootstrapper.initialized,
);
